import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { localStorageService } from 'src/app/services/localstorage.service';
import { MainService } from 'src/app/services/main.service';
import { SharedService } from 'src/app/services/shared.service';
import { SocketsService } from 'src/app/services/socket.service';
import { NgClass } from '@angular/common';
import { BsDropdownDirective, BsDropdownToggleDirective, BsDropdownMenuDirective } from 'ngx-bootstrap/dropdown';
import { FormsModule } from '@angular/forms';
enum NavType {
  All = 0,
  Unread = 2,
  Type = 1,
}

@Component({
    selector: 'app-notifications',
    templateUrl: './notifications.component.html',
    styleUrl: './notifications.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [NgClass, BsDropdownDirective, BsDropdownToggleDirective, BsDropdownMenuDirective, FormsModule]
})
export class NotificationsComponent implements OnInit, OnDestroy {
  NavType = NavType;
  notifications: any[] = [];
  menuList:any[]=[];
  search_string = '';
  type: any;
  filter = 0;
  type_Arr = ['Type', 'Payment Plans', 'Claims', 'Payouts','','Leads']
  selected_nav = 0;
  page_number = 1;
  totalRecords = 0;
  userProfile=this._local.customGetItem('userProfileData');
  // locationFilter: any;
  // locationSubscription: any;
  userInfo: any;
  popup = false;
  doctor_id: any;
  notification_list: any;
  notificationTypes = [
    { id: 1, label: 'Payment Plans'},
    { id: 2, label: 'Claims' },
    { id: 3, label: 'Payouts' },
    { id: 5, label: 'Leads' },
    { id: 7, label: 'Proposals' }
];
  constructor(public _main: MainService, public _router: Router, public _routes: ActivatedRoute, public _socket: SocketsService, private _api: ApiService, private _local: localStorageService, private _shared: SharedService ) { } //public dialogRef: MatDialogRef<NotificationsComponent>

  ngOnInit() {
    this.getNotifications();
    this.userInfo = this._local.customGetItem('user') ? JSON.parse(this._local.customGetItem('user')) : null;
    if (this.userInfo && this.userInfo[0] && this.userInfo[0].role_id == 5) {
      // this.locationFilter = this.globalFilterService.getFilterObj('location');
      // this.locationSubscription = this.globalFilterService.locationFilter
      //   .subscribe((filter: any) => {
      //     this.locationFilter = filter;
      //     this.getNotifications();
      //   });
    }
    this.filter = 0;
    this.type = 'Type';
    this._socket.on(this._shared.socketIds.NEW_NOTIFICATION, (data: any) => {
      this._main.unread_count = data.unread_count;
      
      if (data.data) {
        if (data.data.length > 10) {
          this.notifications = data && data.data.slice(0, 10);
        } else {
          this.notifications = data && data.data;
        }
      }
      this.totalRecords = data.count;
      this.notifications.forEach(element => {
        element.show_sent_at = this._main.covertDateTimesAgo(element.sent_at)
      });
      if (this.filter == 2){
        this.notifications = this.notifications && this.notifications.length ? this.notifications.filter(item => item.read_at === null) : [];
      }
      this.page_number = 1;
    })
    setInterval(() => {
      this.scrollHandler()
    }, 1000)
    if (this.userInfo && this.userInfo[0] && this.userInfo[0].doctor_id) {
      this.doctor_id = this.userInfo[0].doctor_id;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['isDropdownOpen']?.currentValue) {
      this.getNotifications();
    }
  }

  api_hitting = false;
  scrollHandler() {
    var element = document.querySelector('#infinite-scroller');
    if (element) {
      var position = element.getBoundingClientRect();
      if ((position.top >= 0 && position.bottom <= window.innerHeight) || (position.top < window.innerHeight && position.bottom >= 0)) {
        if (this.totalRecords != this.notifications.length && this.api_hitting == false) {
          this.page_number = this.page_number + 1;
          this.getNotifications();
        }
      }
    }
  }

  getNotifications() {
    let params: any = {
      limit: 10,
      offset: (this.page_number - 1) * 10,
      hideLoader: true
    };
    // if (this.locationFilter && this.locationFilter.id) {
    //   params['doctor_id'] = this.locationFilter.id;
    // }
    if (this.type != 'Type'){
      params['type'] = this.notificationTypes.find(id => id.label == this.type)?.id || undefined;
    }

    if (this.filter) {
      params['filter'] = this.filter != 0 ? this.filter : '';
    }

    if (this.search_string) {
      params['search_string'] = this.search_string;
    }
    this.api_hitting = true;
    this._api.api(params, 'profile/fetch_business_notifications', 'get')
      .subscribe((data: any) => {
        if (data.is_error == 0) {
          if (this.page_number == 1) {
            this.notifications = data.data;
          } else {
            this.notifications = [...this.notifications, ...data.data];
          }
          this.notification_list = this.notifications;
          this.totalRecords = data.count;
          this._main.unread_count = data.unread_count;
          this.notifications.forEach(element => {
            element.show_sent_at = this._main.covertDateTimesAgo(element.sent_at)
          });
        }
        this.api_hitting = false;
      })
  }

  readNotification(id?: any) {
    let params: any = {
    };
    if (id) {
      params['bn_id'] = id;
    }
    // if (this.locationFilter && this.locationFilter.id) {
    //   params['doctor_id'] = this.locationFilter.id;
    // }
    this._api.api(params, 'profile/read_business_notifications')
      .subscribe((data: any) => {
        if (data.is_error == 0) {
          this.page_number = 1;
          this.getNotifications();
        }
      })
  }

  private redirectIfValid(path: string, queryParams: any = {}): void {
  const match = this.menuList.find(item => path.includes(item.path));
  if (match || this.userProfile?.role_id !== 5) {
  this._router.navigate([path], { queryParams });
}
}

 navToNotification(notification: any) {
    if (notification && notification.read_at == null) {
      this.readNotification(notification.bn_id);
    }
    switch (notification.type) {
      case 1:
        // contract
        let contract
        if (typeof notification.metadata == 'string') {
          contract = JSON.parse(notification.metadata);
        }
        else {
          contract = notification.metadata;
        }
        if (contract && contract.contract_id){
          this.redirectIfValid(`/app/contracts/details/${contract.contract_id}`);
        }else if (contract.non_verified_count && contract.non_verified_count > 0){
           this.redirectIfValid(`/app/contracts/list`, { queryParams: { contract_filter: 'Non Verified' } })
        }

        break;
      case 2:
        // claim
        let claim
        if (typeof notification.metadata == 'string') {
          claim = JSON.parse(notification.metadata);
        }
        else {
          claim = notification.metadata;
        }
        if (claim && claim.redirect_to_contract && claim.contract_id) {
          this.redirectIfValid(`/app/contracts/details/${claim.contract_id}`);
        } else {
          this.redirectIfValid(`/app/claims/details/${claim.contract_id}`);
        }
        break;
      case 3:
        // payout
        let payout
        if (typeof notification.metadata == 'string') {
          payout = JSON.parse(notification.metadata);
        }
        else {
          payout = notification.metadata;
        }
        if (notification && notification.pn_id == 21) {
           this.redirectIfValid('/app/profile');
        } else {
          // this._router.navigate(['/app/earnings'], { queryParams: { payoutId: payout.payout_id, locationId: this.doctor_id } });
           this.redirectIfValid('/app/earnings');
        }
        break;
      case 4:
        this.redirectIfValid('/app/profile', { queryParams: { tab: 'subscription' } });
        break;
      case 5: {
        let lead_meta_data: any = {};
        if (typeof notification.metadata == 'string') {
          lead_meta_data = JSON.parse(notification.metadata);
        }
        else {
          lead_meta_data = notification.metadata;
        }
        this.redirectIfValid('app/leads/details', { queryParams: { application_id: lead_meta_data['application_id'] } });
        break
      }

      case 6: /// for disputes
        let  dispute;
        if (typeof notification.metadata == 'string') {
          dispute = JSON.parse(notification.metadata);
        }
        else {
          dispute = notification.metadata;
        }
        dispute.id = dispute &&  dispute.contract_id ? dispute.contract_id : dispute.split_req_id     
         this.redirectIfValid(`/app/disputes/details`,{queryParams:dispute.contract_id ? { contract_id: dispute.contract_id } : { split_req_id: dispute.split_req_id }});
        break;

      case 7: 
        let proposal
        if (typeof notification.metadata == 'string') {
          proposal = JSON.parse(notification.metadata);
        }
        else {
          proposal = notification.metadata;
        }
        if (proposal && proposal.poposal_notification_redirect){
          if (proposal.contract_type != 5){
            this.redirectIfValid(`/app/proposals/details/${proposal.split_req_id}`);
          }else if (proposal.contract_type == 5) {
             this.redirectIfValid(`/app/debt-recovery/recovery-details/${proposal.split_req_id}`);
          }
        }
        break;
    }
    this._main.showNotificationBar = false;
  }
  toggleNotificationBar() {
    this._main.showNotificationBar = !this._main.showNotificationBar;
    this.filter = 0;
    this.search_string = '';
    this.type = 'Type';
    this.page_number = 1;
    this.getNotifications()
  }

updateNotifications(nav: NavType, type?: any) {
  this.filter = nav
  this.selected_nav = nav;
  if (nav != this.NavType.Type) {
      this.type = 'Type'
      this.getNotifications()
    } else {

      if (nav == this.NavType.Type && !type) {
        this.filter = nav
      } else {
        this.type = type.label;
        this.page_number = 1;
        this.filter = 0;
        this.getNotifications()
      }
    }
  }

  clearSearch() {
    this.search_string = '';
    this.updateNotifications(this.selected_nav);
  }

  ngOnDestroy(): void {
    this._socket.off(this._shared.socketIds.NEW_NOTIFICATION)
  }

  onInputChange(){
    if (this.search_string.trim() == ''){
      this.getNotifications()
    }
  }
}
